import React, { useState, useEffect, useCallback } from 'react';
import { analyticsService } from '@common/analytics';
import { usePurchaseFlowRenderProps } from '@common/config/purchaseFlowRenderHelpers';
import Const from '../../config/const';
import { isPrerenderMode } from '../../config/util';
import { PurchaseFlowWrapper } from '../purchase_flow';
import classes from './classes.module.scss';

const noNeedRenderAffiliatePromoItem = ({ showItem, noThanksLinkClicked }) => {
  const noNeed = !showItem || noThanksLinkClicked || isPrerenderMode();
  return noNeed;
};

function AffiliatePromoPopup({
  showAffiliatePromoPopup,
  hideAffiliatePromoPopup,
  noNeedCloseIcon = false,
  chatType = Const.chatType.text,
  needUpdatePricingOptions = false,
  noThanksLinkClicked,
  onCloseIconClick,
  affiliatePromoPurchaseSuccess,
  noThanksLinkClickedAction
}) {
  const { renderIcon, renderText } = usePurchaseFlowRenderProps();
  const [needShowAffiliatePromoPopup, setNeedShowAffiliatePromoPopup] = useState(false);

  useEffect(() => {
    setTimeout(() => setNeedShowAffiliatePromoPopup(true), 1000);
  }, []);

  // ==========================================================================
  // Callbacks
  // ==========================================================================

  const handlePurchaseComplete = useCallback(() => {
    if (affiliatePromoPurchaseSuccess) {
      affiliatePromoPurchaseSuccess(chatType, needUpdatePricingOptions);
    }
  }, [affiliatePromoPurchaseSuccess, chatType, needUpdatePricingOptions]);

  const handlePurchaseCancel = useCallback(() => {
    onCloseIconClick();
  }, [onCloseIconClick]);

  const handleDismiss = useCallback(() => {
    hideAffiliatePromoPopup();
    if (noThanksLinkClickedAction) {
      noThanksLinkClickedAction();
    }
  }, [hideAffiliatePromoPopup, noThanksLinkClickedAction]);

  // ==========================================================================
  // Render
  // ==========================================================================

  const noNeed = noNeedRenderAffiliatePromoItem({
    showItem: showAffiliatePromoPopup, noThanksLinkClicked
  });

  if (!needShowAffiliatePromoPopup && isPrerenderMode()) return null;
  if (noNeed) return null;

  return (
    <PurchaseFlowWrapper
      mode="affiliatePromo"
      onComplete={ handlePurchaseComplete }
      onCancel={ handlePurchaseCancel }
      onDismiss={ handleDismiss }
      onAnalyticsEvent={ (...args) => analyticsService.trackEvent(...args) }
      renderIcon={ renderIcon }
      renderText={ renderText }
      inModal
      popoverClassName="affiliate-promo-popup"
      popoverContentClassName={ classes.affiliatePromoPopupContent }
      popoverClosable={ !noNeedCloseIcon }
      // Legacy pass-through props
      chatType={ chatType }
      needUpdatePricingOptions={ needUpdatePricingOptions }
    />
  );
}

export default AffiliatePromoPopup;
